export const PROFILE_LOAD = 'PROFILE_LOAD';
export const PROFILE_LOAD_SUCCESS = 'PROFILE_LOAD_SUCCESS';
export const PROFILE_LOAD_FAIL = 'PROFILE_LOAD_FAIL';